export default __webpack_public_path__ + "static/media/principlesImage.c6e8bbff.svg";